import { LOCALSTORAGE_KEY } from "../../utils/Constants";
import {
  setLoading,
  setCartItems,
  setCart,
  setPujaPriceInfo,
  setTempCartPayLoad,
} from "./../slices/cartSlice";
import { OrderService, CartService } from "td_server/services";
export const updateCartAction = (cartItems: any) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    //localStorage.setItem('cartInfo', JSON.stringify(cartItems));
    dispatch(setCartItems(cartItems));

    dispatch(setLoading(false));
    return Promise.resolve("");
  } catch (error: any) {
    dispatch(setLoading(false));
    return Promise.reject("");
  }
};

export const setCartAction = (cartItems: any) => async (dispatch: any) => {
  try {
    dispatch(setCart(cartItems));
    return Promise.resolve("");
  } catch (error: any) {
    return Promise.reject("");
  }
};

export const emptyCartAction = () => async (dispatch: any) => {
  try {
    //localStorage.removeItem('cartInfo');
    dispatch(setCartItems([]));
    return Promise.resolve("");
  } catch (error: any) {
    return Promise.reject("");
  }
};

export const getPriceOfPuja = (data: any) => async (dispatch: any) => {
  try {
    let priceData = await OrderService.getPriceDetailsOfPuja(data);
    if (priceData) {
      setPujaPriceInfo(priceData);
    }

    return Promise.resolve("");
  } catch (error: any) {
    return Promise.reject("");
  }
};

export const updateTempCartPayloadAction =
  (cartPayload: any) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));
      dispatch(setTempCartPayLoad(cartPayload));
      dispatch(setLoading(false));
      return Promise.resolve("");
    } catch (error: any) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const addAndUpdateCartItem =
  (_userId: any, cartId: any, cartPayload: any) =>
  async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      let loggedInUser = getState().user.userInfo?.phoneNumber;
      const guestCartId = localStorage.getItem(LOCALSTORAGE_KEY.GUESTCARTID);
      const userId = loggedInUser ? loggedInUser : guestCartId;
      if (!userId) return;
      let cartItemsResponse = await CartService.getCart(userId);
      let cartItems = cartItemsResponse?.items;

      // Check if already existing item.
      let filteredCartItem = cartItems.filter(function (item: any) {
        return item.cartId === cartId;
      });

      const priceConversionState = getState().priceConversion.priceConversionRate

      if (filteredCartItem.length) {
        // item already exists so update item
        let updatedResponse = await CartService.updateCartItem(
          userId,
          cartId,
          {addCartRate: priceConversionState,...cartPayload}
        );
      } else {
        // add item
        let addResponse = await CartService.addToCart(userId, {addCartRate: priceConversionState,...cartPayload});
      }

      // dispatch(setTempCartPayLoad(cartPayload));
      dispatch(setLoading(false));
      return Promise.resolve("");
    } catch (error: any) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const removeItemFromCartAction =
  (_userId: any, cartId: any) => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      let loggedInUser = getState().user.userInfo?.phoneNumber;
      const guestCartId = localStorage.getItem(LOCALSTORAGE_KEY.GUESTCARTID);
      const userId = loggedInUser ? loggedInUser : guestCartId;
      if (!userId) return;
      CartService.removeFromCart(userId, cartId);

      // dispatch(setTempCartPayLoad(cartPayload));
      dispatch(setLoading(false));
      return Promise.resolve("");
    } catch (error: any) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const mergeUserAndGuestCart =
  (userId: any, guestId: any) => async (dispatch: any, getState: any) => {
    try {
      if (!userId || !guestId) return;
      dispatch(setLoading(true));
      if (!userId) return;
      await CartService.mergeCartData(userId, guestId);
      // remove guest cartID from localStorage
      localStorage.removeItem(LOCALSTORAGE_KEY.GUESTCARTID);
      dispatch(setLoading(false));
      return Promise.resolve("");
    } catch (error: any) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

// export const validateAndGetCouponDiscountAction =
//   () => async (dispatch: any) => {
//     try {
//       return Promise.resolve(0);
//     } catch (error: any) {
//       return Promise.reject('');
//     }
//   };
